import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function MJGAdminSurprise({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 177.1232605 174.6164856"
      enableBackground="new 0 0 177.1232605 174.6119843"
      xmlSpace="preserve"
    >
      <g id="tyche">
        <g id="surprise_4_">
          <ellipse
            fill="#A6E3F9"
            cx="72"
            cy="71.9977722"
            rx="72"
            ry="71.9977722"
          />
          <g>
            <g>
              <defs>
                <ellipse
                  id="SVGID_1_"
                  cx="72"
                  cy="72.0022278"
                  rx="72"
                  ry="71.9977722"
                />
              </defs>
              <clipPath id="SVGID_2_">
                <use
                  xlinkHref="#SVGID_1_"
                  overflow="visible"
                />
              </clipPath>
              <g
                id="profil_4_"
                clipPath="url(#SVGID_2_)"
              >
                <path
                  fill="#FF7F29"
                  d="M68.467926,16.6284885l-6.1435928,0.7317886l6.8884659,74.2166367l14.3838959-1.1102219 c12.4629517-0.9618683,21.3595963-12.4902649,19.1310577-24.7899933l-4.7625046-26.2843399 C95.4234772,25.3638897,82.6824417,15.5313292,68.467926,16.6284885z"
                />
                <path
                  fill="#FFE500"
                  d="M81.7342148,107.6729965c-6.4197083,4.2170334-8.2054367,12.8398056-3.9885483,19.260025 c0.337738,0.5141449,0.7131653,0.9872513,1.1037521,1.4412155l-0.0113754,0.0084229l36.2861481,42.6131897 l18.1061554-10.2611084l-32.2358704-49.0736923C96.7774506,105.2413483,88.1541519,103.4554749,81.7342148,107.6729965z"
                />
                <circle
                  fill="#FFE500"
                  cx="88.9811554"
                  cy="119.4544067"
                  r="14.3075562"
                />
                <path
                  fill="#FFE500"
                  d="M103.210968,120.1159134l-3.7037888,80.0356827H48.3279648l-21.1496449-84.0514832 c-1.3990574-5.5602417,2.8048306-10.9532013,8.5385265-10.9532013h53.2018623 C97.0801773,105.1469116,103.5882416,111.9631424,103.210968,120.1159134z"
                />
                <path
                  fill="#FFE500"
                  d="M45.8062477,108.8342438c-5.8651047-5.294899-14.9121017-4.8327637-20.2075462,1.032341 c-0.4240551,0.4697342-0.7974815,0.9663162-1.1479073,1.4730225l-0.0113354-0.00914L-9.912756,161.006073 l16.2764931,12.8699799l40.4754028-44.8341522C52.134037,123.176796,51.6719055,114.1292496,45.8062477,108.8342438z"
                />
                <path
                  fill="#283042"
                  d="M105.5566177,54.8042068c-0.0118866,0.0095215-0.0118866,0.0095215-0.0118866,0.0095215"
                />
                <path
                  fill="#FDC9A3"
                  d="M57.6148224,107.0715485c1.0777969,6.5987549,7.3008118,11.0742722,13.8995667,9.9964676 c6.5987549-1.0777969,11.0742645-7.3009186,9.9964676-13.8996735S74.2099304,92.0940781,67.61129,93.171875 C61.0125351,94.2496719,56.536911,100.4728012,57.6148224,107.0715485z"
                />
                <polygon
                  fill="#FDC9A3"
                  points="81.5108566,103.1683426 57.6148224,107.0715485 52.8085823,77.6468582 53.5096512,77.5323486 76.7047272,73.7437592"
                />
                <path
                  fill="#FDC9A3"
                  d="M68.0140915,24.2352238l-1.8586655,0.3036518 c-11.8620567,1.9374619-19.9074135,13.1242065-17.969841,24.9861603l6.6085472,40.4593391l22.498188-3.6748428 c11.2986755-1.8455658,18.9619064-12.500946,17.1163406-23.7995148l-3.5705032-21.8599586 C89.0683136,29.8145103,78.8495331,22.4653797,68.0140915,24.2352238z"
                />
                <line
                  fill="none"
                  stroke="#0E0E11"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeMiterlimit="10"
                  x1="81.5609818"
                  y1="50.9541702"
                  x2="87.3672638"
                  y2="50.5129967"
                />
                <line
                  fill="none"
                  stroke="#0E0E11"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeMiterlimit="10"
                  x1="66.5530624"
                  y1="51.5978508"
                  x2="72.8556671"
                  y2="51.2154884"
                />
                <path
                  fill="#FDC9A3"
                  d="M48.8671494,65.799263l4.9390297-0.8031158l-0.8003387-4.9288788 c-0.4419975-2.7220917-3.0116615-4.5692101-5.7393532-4.1256828l0,0 c-2.7277832,0.4435463-4.5806885,3.0099106-4.1386032,5.7319794l0,0 C43.5699005,64.3957443,46.1394768,66.2428818,48.8671494,65.799263z"
                />
                <ellipse
                  transform="matrix(0.9984514 -0.0556306 0.0556306 0.9984514 -3.0874879 3.9798145)"
                  fill="#0E0E11"
                  cx="69.9408875"
                  cy="57.4467468"
                  rx="1.6411057"
                  ry="2.1177406"
                />
                <ellipse
                  transform="matrix(0.9984514 -0.0556306 0.0556306 0.9984514 -3.0217559 4.765295)"
                  fill="#0E0E11"
                  cx="84.0823975"
                  cy="56.6588249"
                  rx="1.6411057"
                  ry="2.1177406"
                />
                <path
                  fill="#FF7F29"
                  d="M62.8640251,92.2811737l-9.5323372,0.7357101 c-9.1671486,0.7076263-16.8931656-6.7528992-16.5065804-15.9391479l1.4026413-33.3281898 c0.5919151-14.0651932,11.6031761-25.4683609,25.639019-26.551754l1.2852859-0.0991859l2.0878448,15.3381233 c0.4040909,5.2352943-1.0067139,14.4091072-3.4134178,19.0759697l-6.6670456,9.9539261 c-5.0052223,9.7057076-0.9119186,22.1268272,5.7044907,30.814579L62.8640251,92.2811737z"
                />
                <path
                  fill="#FF7F29"
                  d="M62.6498375,24.1440258l14.2547493,14.9281864 c5.1092377,5.3505516,12.3512955,8.1238594,19.7275467,7.5545235l0,0l1.0328751,13.3824348l-1.6154327-20.9298363 c-0.7421722-9.6150169-9.1383057-16.8079872-18.7533264-16.0658169L62.6498375,24.1440258z"
                />
                <path
                  fill="#FFE500"
                  d="M65.9319305,140.5347137l21.1364441-16.0259933l16.9491348,22.3457718l-0.0121307,0.0089722 c0.9427109,1.2424774,1.6917496,2.6633301,2.1598969,4.2480011c2.0742188,7.022995-1.937355,14.3974762-8.9602585,16.4717102 c-5.4382477,1.6065826-11.0764008-0.4471436-14.3119125-4.7121735l-0.0121384,0.009491L65.9319305,140.5347137z"
                />
                <path
                  fill="#FFFFFF"
                  d="M93.4542389,168.1285248c-2.6762924,0-5.271904-0.8110504-7.5050278-2.3454285l1.1553726-1.6812439 c2.7838898,1.9140015,6.2879486,2.479538,9.5230484,1.5251007c2.8734436-0.8487854,5.2449722-2.766037,6.6763382-5.3986816 c1.4332047-2.6325226,1.7539673-5.6650696,0.9053879-8.539032c-0.3805313-1.2858124-0.9960556-2.4948425-1.8287277-3.5932007 l-1.2479782-1.6448212l0.0128479-0.0087738l-8.1224899-10.7075958l1.6254578-1.2327881l9.3776093,12.3639526 l-0.0110092,0.0087738c0.9770889,1.2923431,1.7012329,2.717392,2.1504059,4.2361603 c1.0040207,3.3970642,0.6235886,6.9809875-1.0696945,10.0921783c-1.691246,3.1109772-4.4941025,5.3769531-7.8904572,6.3800507 C95.9801865,167.9451447,94.7182312,168.1285248,93.4542389,168.1285248z"
                />
                <path
                  fill="#FFFFFF"
                  d="M63.8106842,168.1285248c-2.6762848,0-5.2719994-0.8110504-7.5040054-2.34552l1.1553726-1.6810455 c2.7838898,1.9138947,6.288868,2.4794312,9.5219345,1.5249939c1.2310486-0.3635101,2.3744888-0.9232483,3.4014511-1.6638031 l1.1932144,1.6541138c-1.2132034,0.8756104-2.5648117,1.5371246-4.016983,1.9660034 C66.3375549,167.944931,65.0755997,168.1285248,63.8106842,168.1285248z"
                />
                <path
                  fill="#FFE500"
                  d="M-8.3045292,174.965744c4.3783441,3.8374481,11.0385962,3.3989868,14.8760357-0.9793549 c3.8375511-4.3783417,3.3989811-11.0386047-0.9793634-14.8761444 c-4.3783445-3.8374481-11.0385962-3.3989868-14.8760357,0.9794617 C-13.1214447,164.4680634-12.6828737,171.1283112-8.3045292,174.965744z"
                />
                <polygon
                  fill="#FFE500"
                  points="7.2635369,165.4305878 31.1323586,209.5862274 20.6612091,217.7761688 -10.5731049,172.1364288"
                />
                <path
                  fill="#FFE500"
                  d="M117.0167007,155.1039581c4.8361282-3.2415466,11.3844376-1.9489136,14.6259842,2.887207 c3.2416687,4.8361511,1.9489288,11.3844452-2.887207,14.6261139 c-4.8361359,3.2415466-11.3844452,1.9489136-14.6259842-2.8873138 C110.887825,164.8938141,112.1805725,158.34552,117.0167007,155.1039581z"
                />
                <path
                  fill="#FDC9A3"
                  d="M172.5358429,103.3054886c3.0120392,3.2155075,2.8471527,8.2638855-0.3682404,11.2758484 c-3.2155151,3.0120392-8.2638855,2.8471527-11.2759552-0.3682556 c-3.0120392-3.2155075-2.8471527-8.2638855,0.3683624-11.2759323 C164.4753876,99.9251862,169.5237732,100.0900726,172.5358429,103.3054886z"
                />
                <polygon
                  fill="#FDC9A3"
                  points="159.8433228,104.7008667 151.4826813,116.1998901 161.9799042,124.3563995 172.1676025,114.581337"
                />
                <path
                  fill="#FDC9A3"
                  d="M160.8320312,115.0281143c-2.8915405-2.250946-7.0603485-1.731636-9.3112946,1.1600189 c-2.250946,2.8915405-1.7316437,7.0603409,1.1600037,9.3112946c2.8915405,2.250946,7.0604553,1.7316437,9.3112946-1.1600113 C164.242981,121.4478683,163.7236786,117.2789612,160.8320312,115.0281143z"
                />
                <polygon
                  fill="#FFE500"
                  points="131.131424,170.4285583 161.9799042,124.3563995 151.2550659,116.3808365 114.4026108,157.6175385"
                />
                <path
                  fill="#FDC9A3"
                  d="M172.4667358,96.307579l-8.6971741,11.8533096 c-0.4496613,0.6128387-1.318985,0.7463531-1.9318237,0.2966919l-0.5802917-0.4257889 c-0.6128387-0.4496613-0.7463531-1.3189774-0.2966919-1.9318161l8.6971893-11.8533173 c0.4496613-0.6128387,1.3189697-0.7463455,1.9318085-0.2966843l0.580307,0.4257812 C172.7828979,94.8254166,172.9163971,95.6947403,172.4667358,96.307579z"
                />
              </g>
            </g>
          </g>
          <path
            fill="#FFE500"
            d="M84.1661835,107.8860016c-6.4197083,4.2170334-8.2054367,12.8398056-3.9885483,19.2600327 c0.337738,0.5141373,0.7131653,0.9872513,1.1037521,1.4412003l-0.0113754,0.0084229l36.2861481,42.613205l18.106163-10.2611237 l-32.235878-49.0736847C99.2094193,105.4543533,90.5861282,103.6684875,84.1661835,107.8860016z"
          />
          <path
            fill="#FFE500"
            d="M119.4486694,155.3169708c4.8361282-3.2415619,11.3844299-1.9489288,14.6259918,2.887207 c3.2416687,4.8361359,1.9489288,11.3844299-2.8872223,14.6260986c-4.8361282,3.2415619-11.3844299,1.9489288-14.6259766-2.8873138 C113.3197937,165.1068268,114.6125412,158.5585327,119.4486694,155.3169708z"
          />
          <path
            fill="#FDC9A3"
            d="M174.967804,103.5184937c3.0120392,3.2155075,2.8471527,8.2638855-0.3682404,11.2758484 c-3.2154999,3.0120468-8.2638855,2.8471527-11.2759399-0.3682556c-3.0120392-3.2155075-2.8471527-8.2638855,0.3683472-11.2759247 C166.9073639,100.1381912,171.9557495,100.3030777,174.967804,103.5184937z"
          />
          <polygon
            fill="#FDC9A3"
            points="162.2752991,104.9138718 153.9146576,116.4128952 164.4118805,124.5694046 174.5995636,114.794342"
          />
          <path
            fill="#FDC9A3"
            d="M163.2639923,115.2411194c-2.8915405-2.250946-7.0603485-1.731636-9.3112946,1.1600189 c-2.250946,2.8915405-1.7316284,7.0603409,1.1600189,9.3112946c2.8915405,2.250946,7.0604553,1.7316437,9.3112946-1.1600113 C166.6749573,121.660881,166.1556549,117.4919662,163.2639923,115.2411194z"
          />
          <polygon
            fill="#FFE500"
            points="133.5634003,170.641571 164.4118805,124.5694046 153.687027,116.5938416 116.8345795,157.8305359"
          />
          <path
            fill="#FDC9A3"
            d="M174.8987122,96.5205841l-8.6971893,11.8533173 c-0.4496613,0.6128387-1.3189697,0.7463455-1.9318085,0.2966843l-0.580307-0.4257889 c-0.6128387-0.4496613-0.7463379-1.3189774-0.2966766-1.9318161l8.6971741-11.8533173 c0.4496613-0.6128387,1.318985-0.7463455,1.9318237-0.2966843l0.5802917,0.4257889 C175.214859,95.0384293,175.3483734,95.9077454,174.8987122,96.5205841z"
          />
          <ellipse
            fill="#FFFFFF"
            cx="79.7340851"
            cy="72.9634247"
            rx="1.8414383"
            ry="2.4704971"
          />
        </g>
      </g>
    </svg>
  );
}

export default MJGAdminSurprise;
